/* eslint-disable */
import type * as Types from '../../../../graphql/gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetShowPastQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  userId: Types.Scalars['String'];
}>;


export type GetShowPastQuery = { __typename?: 'Query', getMyMetrics?: { __typename?: 'MyMetrics', show_past?: boolean | undefined } | undefined };

export type ToggleShowPastMutationVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  userId: Types.Scalars['String'];
}>;


export type ToggleShowPastMutation = { __typename?: 'Mutation', toggleShowPast?: { __typename?: 'MyMetrics', show_past?: boolean | undefined } | undefined };

export type GetUserSettingsQueryVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  propertyId?: Types.InputMaybe<Types.Scalars['String']>;
  scope?: Types.InputMaybe<Types.SettingsScope>;
}>;


export type GetUserSettingsQuery = { __typename?: 'Query', getUserSettings?: { __typename?: 'UserSettings', user_id: string, property_id?: string | undefined, scope?: Types.SettingsScope | undefined, settings?: any | undefined, updated_at?: string | undefined } | undefined };

export type SaveUserSettingMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  propertyId?: Types.InputMaybe<Types.Scalars['String']>;
  scope: Types.SettingsScope;
  key: Types.Scalars['String'];
  value: Types.Scalars['AWSJSON'];
}>;


export type SaveUserSettingMutation = { __typename?: 'Mutation', saveUserSetting?: { __typename?: 'UserSettings', settings?: any | undefined, updated_at?: string | undefined } | undefined };

export type BatchSaveUserSettingsMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  propertyId?: Types.InputMaybe<Types.Scalars['String']>;
  scope: Types.SettingsScope;
  settings: Types.Scalars['AWSJSON'];
}>;


export type BatchSaveUserSettingsMutation = { __typename?: 'Mutation', batchSaveUserSettings?: { __typename?: 'UserSettings', settings?: any | undefined, updated_at?: string | undefined } | undefined };


export const GetShowPastDocument = gql`
    query GetShowPast($propertyId: String!, $userId: String!) {
  getMyMetrics(propertyId: $propertyId, userId: $userId) {
    show_past
  }
}
    `;

/**
 * __useGetShowPastQuery__
 *
 * To run a query within a React component, call `useGetShowPastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowPastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowPastQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetShowPastQuery(baseOptions: Apollo.QueryHookOptions<GetShowPastQuery, GetShowPastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShowPastQuery, GetShowPastQueryVariables>(GetShowPastDocument, options);
      }
export function useGetShowPastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShowPastQuery, GetShowPastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShowPastQuery, GetShowPastQueryVariables>(GetShowPastDocument, options);
        }
export type GetShowPastQueryHookResult = ReturnType<typeof useGetShowPastQuery>;
export type GetShowPastLazyQueryHookResult = ReturnType<typeof useGetShowPastLazyQuery>;
export type GetShowPastQueryResult = Apollo.QueryResult<GetShowPastQuery, GetShowPastQueryVariables>;
export const ToggleShowPastDocument = gql`
    mutation ToggleShowPast($propertyId: String!, $userId: String!) {
  toggleShowPast(propertyId: $propertyId, userId: $userId) {
    show_past
  }
}
    `;
export type ToggleShowPastMutationFn = Apollo.MutationFunction<ToggleShowPastMutation, ToggleShowPastMutationVariables>;

/**
 * __useToggleShowPastMutation__
 *
 * To run a mutation, you first call `useToggleShowPastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleShowPastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleShowPastMutation, { data, loading, error }] = useToggleShowPastMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleShowPastMutation(baseOptions?: Apollo.MutationHookOptions<ToggleShowPastMutation, ToggleShowPastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleShowPastMutation, ToggleShowPastMutationVariables>(ToggleShowPastDocument, options);
      }
export type ToggleShowPastMutationHookResult = ReturnType<typeof useToggleShowPastMutation>;
export type ToggleShowPastMutationResult = Apollo.MutationResult<ToggleShowPastMutation>;
export type ToggleShowPastMutationOptions = Apollo.BaseMutationOptions<ToggleShowPastMutation, ToggleShowPastMutationVariables>;
export const GetUserSettingsDocument = gql`
    query GetUserSettings($userId: String!, $propertyId: String, $scope: SettingsScope) {
  getUserSettings(userId: $userId, propertyId: $propertyId, scope: $scope) {
    user_id
    property_id
    scope
    settings
    updated_at
  }
}
    `;

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      propertyId: // value for 'propertyId'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetUserSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
      }
export function useGetUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
        }
export type GetUserSettingsQueryHookResult = ReturnType<typeof useGetUserSettingsQuery>;
export type GetUserSettingsLazyQueryHookResult = ReturnType<typeof useGetUserSettingsLazyQuery>;
export type GetUserSettingsQueryResult = Apollo.QueryResult<GetUserSettingsQuery, GetUserSettingsQueryVariables>;
export const SaveUserSettingDocument = gql`
    mutation SaveUserSetting($userId: String!, $propertyId: String, $scope: SettingsScope!, $key: String!, $value: AWSJSON!) {
  saveUserSetting(
    userId: $userId
    propertyId: $propertyId
    scope: $scope
    key: $key
    value: $value
  ) {
    settings
    updated_at
  }
}
    `;
export type SaveUserSettingMutationFn = Apollo.MutationFunction<SaveUserSettingMutation, SaveUserSettingMutationVariables>;

/**
 * __useSaveUserSettingMutation__
 *
 * To run a mutation, you first call `useSaveUserSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserSettingMutation, { data, loading, error }] = useSaveUserSettingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      propertyId: // value for 'propertyId'
 *      scope: // value for 'scope'
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveUserSettingMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserSettingMutation, SaveUserSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserSettingMutation, SaveUserSettingMutationVariables>(SaveUserSettingDocument, options);
      }
export type SaveUserSettingMutationHookResult = ReturnType<typeof useSaveUserSettingMutation>;
export type SaveUserSettingMutationResult = Apollo.MutationResult<SaveUserSettingMutation>;
export type SaveUserSettingMutationOptions = Apollo.BaseMutationOptions<SaveUserSettingMutation, SaveUserSettingMutationVariables>;
export const BatchSaveUserSettingsDocument = gql`
    mutation BatchSaveUserSettings($userId: String!, $propertyId: String, $scope: SettingsScope!, $settings: AWSJSON!) {
  batchSaveUserSettings(
    userId: $userId
    propertyId: $propertyId
    scope: $scope
    settings: $settings
  ) {
    settings
    updated_at
  }
}
    `;
export type BatchSaveUserSettingsMutationFn = Apollo.MutationFunction<BatchSaveUserSettingsMutation, BatchSaveUserSettingsMutationVariables>;

/**
 * __useBatchSaveUserSettingsMutation__
 *
 * To run a mutation, you first call `useBatchSaveUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchSaveUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchSaveUserSettingsMutation, { data, loading, error }] = useBatchSaveUserSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      propertyId: // value for 'propertyId'
 *      scope: // value for 'scope'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useBatchSaveUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<BatchSaveUserSettingsMutation, BatchSaveUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchSaveUserSettingsMutation, BatchSaveUserSettingsMutationVariables>(BatchSaveUserSettingsDocument, options);
      }
export type BatchSaveUserSettingsMutationHookResult = ReturnType<typeof useBatchSaveUserSettingsMutation>;
export type BatchSaveUserSettingsMutationResult = Apollo.MutationResult<BatchSaveUserSettingsMutation>;
export type BatchSaveUserSettingsMutationOptions = Apollo.BaseMutationOptions<BatchSaveUserSettingsMutation, BatchSaveUserSettingsMutationVariables>;
export const namedOperations = {
  Query: {
    GetShowPast: 'GetShowPast',
    GetUserSettings: 'GetUserSettings'
  },
  Mutation: {
    ToggleShowPast: 'ToggleShowPast',
    SaveUserSetting: 'SaveUserSetting',
    BatchSaveUserSettings: 'BatchSaveUserSettings'
  }
}